import { render, staticRenderFns } from "./KioskHeader.vue?vue&type=template&id=1d51dd8e&"
import script from "./KioskHeader.vue?vue&type=script&lang=js&"
export * from "./KioskHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports